import { useI18n } from "@/lib/i18n";
import { Check } from "lucide-react";

export default function Features({ features = [] }) {
    const { t, pick } = useI18n();
    if (!features.length) return null;
    return (
        <section id="features" data-testid="features-section" className="bg-[#0F172A] text-white py-24 relative overflow-hidden">
            <div aria-hidden className="absolute -top-40 right-0 h-[34rem] w-[34rem] bm-glow-emerald opacity-30" />
            <div aria-hidden className="absolute -bottom-40 left-0 h-[34rem] w-[34rem] bm-glow-champagne opacity-25" />
            <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
                <div className="max-w-2xl">
                    <div className="text-xs uppercase tracking-[0.22em] font-semibold text-[#C8A96B]">
                        {t("sections.features_title")}
                    </div>
                    <h2 className="mt-2 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
                        {t("sections.features_sub")}
                    </h2>
                </div>

                <ul className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5">
                    {features.map((f, i) => (
                        <li
                            key={i}
                            data-testid={`feature-${i}`}
                            className="flex items-center gap-3 rounded-xl bg-white/[0.04] border border-white/10 px-4 py-3 hover:bg-white/[0.07] transition-colors"
                        >
                            <span className="size-7 rounded-lg bg-[#10B981]/20 flex items-center justify-center shrink-0">
                                <Check className="size-3.5 text-[#10B981]" />
                            </span>
                            <span className="text-sm text-white/85">{pick(f)}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
